export default __webpack_public_path__ + "static/media/37c8749b536d6a27.6613c9a172a206f41cb0d446b4370a52.svg";